import React from "react";

import Text from "../Typography/Text";

import styles from "./CheckboxSection.module.css";

interface Props {
  header: string;
}

const CheckboxSection: React.FC<React.PropsWithChildren<Props>> = ({
  header,
  children,
}) => {
  return (
    <div className={styles.container}>
      <Text variant="body" color="text">
        {header}
      </Text>
      <div className={styles.grid}>{children}</div>
    </div>
  );
};

export default CheckboxSection;
